import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=2c526003&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=ts"
export * from "./RoleList.vue?vue&type=script&lang=ts"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=2c526003&prod&lang=less"
import style1 from "./RoleList.vue?vue&type=style&index=1&id=2c526003&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c526003",
  null
  
)

export default component.exports